export const WorkData = [
  {
    id: 1,
    name: "Crypto_Hunter",
    description:
      "WebApp enables users to get information regarding current market status of cryptocurrenices.",
    tags: [
      "react",
      "material-ui",
      "charJs",
      "Rapid api",
    ],

    demo: "https://crypto-hunter-s.netlify.app/",
    github: "https://github.com/dev-shubham01/Crypto_Hunter.git",
    img: "CH.png",
    side: true,
  },
  {
    id: 2,
    name: "Mobivax",
    description:
      "A WebApp to register and vaccinate people at home.",
    tags: [ "React","Mapbox", "MERN","Twilio"],

    demo: "https://mobivax.netlify.app/",
    github: "https://github.com/dev-shubham01/Mobivax",
    img: "MV.png",
    side: false,
  },
  
];
